module.exports = __webpack_public_path__ + "static/media/mb.7dd4996e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/june-5/races/images/mb.png
// module id = 672
// module chunks = 40 50